import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import Template from 'text-loader!../templates/dashboard.template.htm';
import Cards_Template from 'text-loader!../templates/partial_templates/dashboard_cards.template.htm';
import Venue_Cards_Template from 'text-loader!../templates/partial_templates/dashboard_venues_cards.template.htm';
import Queue_Cards_Template from 'text-loader!../templates/partial_templates/dashboard_queues_cards.template.html';
import DashboardDetailsCollection from '../models/dashboard.paginated.collection.ts';
import Pagination from '../views/pagination.view.ts';
import 'dhtmlxMessage';
import i18n  from "l10n";

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
    cardsTemplate: Handlebars.compile(Cards_Template),
    venueCardsTemplate: Handlebars.compile(Venue_Cards_Template),
    queueCardsTemplate: Handlebars.compile(Queue_Cards_Template),
	templateParams: {},
    DashboardDetailsCollection: null,
	model: null,
	queuesNames: null,
	loadingId: null,
	initialize: function (options) {
		var self = this;

        this.userData = options.data;
        this.numberPrivilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);
        this.venueId = this.userData.venueId;

        this.loadDashboardDetails();

        $(window).off("popstate").on("popstate", function() {
            if(self.autoRefreshTimer)
                clearInterval(self.autoRefreshTimer);
        });

        if(this.autoRefreshTimer)
            clearInterval(this.autoRefreshTimer);

        this.autoRefreshTimer = setInterval(function() {
            $(".dashboardCardProgress").show();
            if (self.dashboardDetailsCollection.state.currentPage >= self.dashboardDetailsCollection.state.lastPage) {
                self.dashboardDetailsCollection.getFirstPage();
            }
            else {
                self.dashboardDetailsCollection.getNextPage();
            }
        }, 7000);

	},
    loadDashboardDetails: function()
	{
		var self = this;

        this.dashboardDetailsCollection = new DashboardDetailsCollection();
		this.dashboardDetailsCollection.url = 'rest/api/user/dashboard';
		this.dashboardDetailsCollection.on( 'sync', this.successDashboardDetailsData, this );
		this.dashboardDetailsCollection.on( 'error', this.errorDashboardDetailsData, this );
		if (this.numberPrivilegeLevel == 2)
            this.dashboardDetailsCollection.state.pageSize = 3;
        else
            this.dashboardDetailsCollection.state.pageSize = 4;
		this.dashboardDetailsCollection.getFirstPage();
	},
	successDashboardDetailsData: function(response)
	{
        this.render();

        if(response.models.length > 0) {
            this.pagination = new Pagination({ collection : this.dashboardDetailsCollection });
            this.pagination.render();
            $('#dashboard_card_pagination').html( this.pagination.$el );
            $('#dashboard_card_pagination').hide();
        }
	},
	errorDashboardDetailsData: function(collection, xhr, options)
	{
		this.onErrorHandler(collection, xhr, options);
	},

	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

        var data = this.dashboardDetailsCollection.models[0].attributes;
		this.$el.html(this.template( { privilegeLevel : this.numberPrivilegeLevel, data: data } ));
	},
	events:{

	}
});

